// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-J":"J_sp-175w-J___gdEV"};